module.exports = __webpack_public_path__ + "static/media/Corrigendum.aee5db10.pdf";